import axios from 'axios'

export default {
  namespaced: true,
  state: {
    data: null,
    status:''
  },
  getters: {
		data: state => state.data,


		userIsRequester: (state, getters) => (user_id) => {
			if (state.data) {
				if (state.data.requesterId == user_id ){
					return true;
				}
				if (state.data.altRequester) {
					let x = 0;
					for (x = 0; x < state.data.altRequester.length; x++) {
						if (user_id + "" == state.data.altRequester[x].userId + "") {
							return true;
						}
					}
				}
			}
			return false;
		},


  },
  mutations: {
    setData(state, payload) {
      state.data = payload;
    },
    save_start(state, payload) {
      state.data = payload;
      state.status = '';
    },
    save_success(state, payload) {
      state.data = payload;
      state.status = '';
    }
    ,
    save_error(state) {
      state.status = 'error'
    }
  },
  actions: {
    async save({commit}, lcr){
        return new Promise((resolve, reject) => {
          commit('save_start')
          axios({url: this.state.apiUrl+'/lane-closure-request', data: lcr, method: 'POST' })
          .then(resp => {
            commit('save_success', resp.data)
            resolve(resp)
          })
          .catch(error => {
            commit('save_error')
            reject(error)
          })
        })
    },

  }

}
